import React from "react";
/// React router dom
import { Routes, Route, Outlet } from "react-router-dom";
/// Css
import "./index.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";

/// Dashboard




import ScrollToTop from "./layouts/ScrollToTop";

import AppConfig from "./pages/AppConfig/AppConfig";
import CategoryConfig from "./pages/AppConfig/CategoryConfig";
import UserDetails from "./pages/UserDetails";

import Terms from "./pages/TermsConditon";
import PrivacyPolicy from "./pages/PrivacyPolicy";

import About from "./pages/About";
import { Search } from "lucide-react";

import Subjects from "./pages/Subjects";


import Dashboard from "./pages/DashBoard";
import Dashboards from "./pages/DashBoard";

import AboutForm from "./pages/AboutUsForm";

import Users from "./pages/UserManagement";
import Vendors from "./pages/Vendors";
import ChatPage from "./pages/ChatPage";
import Contracts from "./pages/Contract";
import ContractDetail from "./pages/ContractDetail";
import CategoryVendors from "./pages/CategoryVendor";


const Markup = () => {
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];

  const allroutes = [
    /// Dashboard
    { url: "", component: <Dashboard /> },


    { url: "user-detail/:id", component: <UserDetails /> },

    { url: "users", component: <Users /> },

    { url: "terms-condition", component: <Terms /> },

    { url: "dashboards", component: <Dashboards /> },

    { url: "privacy-policy", component: <PrivacyPolicy /> },

    { url: "about", component: <About /> },
    { url: "category", component: <Subjects /> },

    { url: "/admin/about-form", component: <AboutForm /> },

    { url: "/chat", component: <ChatPage /> },

    { url: "/vendors/:id", component: <Vendors /> },
    { url: "/vendors", component: <CategoryVendors /> },
  ];

  return (
    <>
      <Routes>
        <Route element={<MainLayout />}>
          {allroutes.map((data, i) => (
            <Route
              key={i}
              exact
              path={`${data.url}`}
              element={data.component}
            />
          ))}
        </Route>
      </Routes>
      <ScrollToTop />
    </>
  );
};

function MainLayout() {
  //const { menuToggle, sidebariconHover } = useContext(ThemeContext);
  return (
    <>
      <div id="main-wrapper" className={`show`}>
        {/* <div id="main-wrapper" className={`show ${sidebariconHover ? "iconhover-toggle": ""} ${ menuToggle ? "menu-toggle" : ""}`}>   */}
        <Nav />
        <div
          className="content-body"
          style={{ minHeight: window.screen.height - 140 }}
        >
          <div className="container-fluid bdy">
            <Outlet />
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}
function FrontLayout() {
  return (
    <>
      <div className="overflow-unset">
        {/* <Layout /> */}
        <Outlet />
      </div>
    </>
  );
}

export default Markup;
